import { render, staticRenderFns } from "./PyramidLevels.vue?vue&type=template&id=f48828f2&"
import script from "./PyramidLevels.vue?vue&type=script&lang=js&"
export * from "./PyramidLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports